import { SectionLayout } from "@mittwald/flow-components/dist/components/Section/components";
import type { FC } from "react";
import React from "react";
import type DedicatedServerArticle from "../../../../model/article/DedicatedServerArticle";
import MachineTypeSection from "../../../../pages/app/server/modals/OrderServerWizard/components/MachineTypeSection";
import StorageSection from "../../../../pages/app/server/modals/OrderServerWizard/components/StorageSection";

interface Props {
  article: DedicatedServerArticle;
}

export const ConfigurationSection: FC<Props> = (props) => {
  return (
    <SectionLayout>
      <MachineTypeSection article={props.article} />
      <StorageSection article={props.article} />
    </SectionLayout>
  );
};

export default ConfigurationSection;
